import { render, staticRenderFns } from "./hotPanelImg.vue?vue&type=template&id=c8a14808&scoped=true"
import script from "./hotPanelImg.vue?vue&type=script&lang=js"
export * from "./hotPanelImg.vue?vue&type=script&lang=js"
import style0 from "./hotPanelImg.vue?vue&type=style&index=0&id=c8a14808&prod&lang=less&scoped=true"
import style1 from "./hotPanelImg.vue?vue&type=style&index=1&id=c8a14808&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a14808",
  null
  
)

export default component.exports